export default __webpack_public_path__ + "static/media/100-deer.b9fb3419.webp";